<template>
  <component :is="layout">
    <keep-alive :include="cachedComponents" :key="keepAliveKey">
      <router-view />
    </keep-alive>
  </component>
</template>

<!-- <script src="../public/js/vconsole.min.js"></script> -->
<script>
const DefaultLayout = () =>
  import(/* webpackChunkName: "vsf-layout-default" */ "./layouts/Default");
  import {EventBus} from "../public/js/eventBus";
export default {
  name: `App`,
  data() {
    return {
      cachedComponents: ['TarotShuffleForm', 'Clairvoyance', 'NewYearBaydin', 'CompatabilityLoveForm', 'Special', 'Tarot'],
      keepAliveKey: 0,
    }
  },
  created() {
    EventBus.$on('clear-cache', this.handleClearCache);
  },
  beforeDestroy() {
    EventBus.$off('clear-cache', this.handleClearCache);
  },
  methods: {
    handleClearCache() {
      this.cachedComponents = [];
      setTimeout(() => {
        this.cachedComponents = ['TarotShuffleForm', 'Clairvoyance', 'NewYearBaydin', 'CompatabilityLoveForm', 'Special', 'Tarot'];
      }, 3000);
    },
  },
  components: {
    DefaultLayout,
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    },
    // kbzToken() {
    //   return this.$store.state.kbzToken;
    // }
  },
  async beforeCreate() {
    console.log('Before Create App');
    
    await this.$store.dispatch('fetchKBZToken');
    // await window.ma.callNativeAPI('setNavigationBarTitle', {title: '1875 Bay Din'}, result => {
    //   console.log("new title: ", result);
    // })
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html {
  line-height: 1.6;
  color: #333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  /* Disable pinch-zoom while keeping scroll/pan (viewport alone is ignored on iOS 10+). */
  touch-action: pan-x pan-y;
  overscroll-behavior-y: contain;
}

body,
img,
canvas {
  touch-action: pan-x pan-y;
}

p {
  &:not(:first-child) {
    margin-top: 1.25em;
  }
}

.mm-font {
  font-family: Unicode;
}

input::placeholder {
  color: grey !important;
}

.t_c_agreement {
  color: slategrey;
  font-size: 12px; 
  font-weight: normal;
}

.t_c_agreement span {
  text-decoration: underline;
  color: #333;
  cursor: pointer;
}

.tnc {
  border: 2px solid black;
  border-radius: 10px;
  height: calc(100vh - 150px); 
  margin: -15px;
  overflow: hidden; 
  padding: 10px;
}

.scroll-text {
  max-height: calc(100% - 20px); 
  overflow-y: auto;
}

/* ---- Leave-confirm dialog (TarotShuffle / CompatabilityLove) ---- */
/* Fixed compact size + forced side-by-side buttons so the modal looks
   identical on every device (SweetAlert2 defaults wrap buttons to a
   column on narrow screens, which caused the Image 1 vs Image 2 split). */
.swal2-popup.leave-confirm-popup {
  width: clamp(280px, 45vw, 320px) !important;
  max-width: calc(100vw - 48px);
  box-sizing: border-box;
  margin: auto !important;
  border-radius: 26px;
  border: 1px solid #ffdcc0;
  padding: 20px 16px 16px;
  box-shadow: 0 18px 50px rgba(31, 41, 55, 0.22);
}

.leave-confirm-popup .swal2-title {
  font-family: "Padauk", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.6;
  min-height: 2.8em;
  padding-top: 0.3em;
}

.leave-confirm-popup .swal2-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 8px;
  transform: none;
}

.leave-confirm-popup .swal2-actions {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 10px !important;
  width: 100% !important;
  margin: 14px 0 0 !important;
  padding: 0 !important;
}

.swal2-popup.leave-confirm-popup .swal2-styled {
  flex: 1 1 0 !important;
  min-width: 0 !important;
  margin: 0 !important;
  white-space: nowrap !important;
  border-radius: 999px;
  font-family: "Padauk", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 11px 6px;
}

.swal2-popup.leave-confirm-popup .swal2-confirm {
  background: linear-gradient(135deg, #ff7010, #ff9338);
  box-shadow: 0 6px 18px rgba(255, 112, 16, 0.4);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.swal2-popup.leave-confirm-popup .swal2-confirm:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(255, 112, 16, 0.5);
}

.swal2-popup.leave-confirm-popup .swal2-confirm:active {
  transform: scale(0.97);
}

.swal2-popup.leave-confirm-popup .swal2-cancel {
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #4b5563;
  box-shadow: none;
}

.swal2-popup.leave-confirm-popup .swal2-cancel:hover {
  background-color: #e5e7eb;
}

</style>
